// External Imports
import React from 'react';
import { Stack } from '@lessonnine/design-system.lib';

// Internal Imports
import { ContentList } from '../ContentList/ContentList.jsx';
import { LANDING_PAGE } from '../../config/types/prop.js';
import { ShowMoreButton } from '../ShowMoreButton/ShowMoreButton.jsx';
import { ListViewContext } from '../../context/listView.js';
import { useAccessibilityFocusLastAfterLoading } from '../../hooks/useAccessibilityFocusLastAfterLoading.js';
import { Divider } from '../Divider/Divider.jsx';
import { ScreenReaderOnly } from '../ScreenReaderOnly/ScreenReaderOnly.jsx';

// Component Definition
function Homepage({ relatedItems, loadingMore, onLoadMore, pagination: { hasMore } }) {
  const handleFocus = useAccessibilityFocusLastAfterLoading({ loading: loadingMore });
  const showLoadMore = hasMore || loadingMore;

  // Sequences of two-up and three-up sections.
  // If more articles can be loaded, only renders complete rows,
  // Otherwise, the last row may be incomplete.
  const feedSequences = hasMore
    ? [
        [relatedItems.slice(0, 2), relatedItems.slice(2, 8)],
        [relatedItems.slice(8, 10), relatedItems.slice(10, -1)],
      ]
    : [
        [relatedItems.slice(0, 2), relatedItems.slice(2, 8)],
        [relatedItems.slice(8, 10), relatedItems.slice(10)],
      ];

  return (
    <section data-testid="homepage">
      {/* TODO: we should have translations for this */}
      <ScreenReaderOnly as="h1">Homepage</ScreenReaderOnly>
      <Stack>
        {feedSequences.map((sequence) => (
          <>
            <ListViewContext.Provider value="twoUp">
              <ContentList
                onFocus={handleFocus}
                items={sequence[0]}
                interstitials={[
                  {
                    content: <Divider />,
                    count: Number.POSITIVE_INFINITY,
                    frequency: 3,
                  },
                ]}
              />
            </ListViewContext.Provider>
            <Divider />
            <ListViewContext.Provider value="threeUp">
              <ContentList
                onFocus={handleFocus}
                items={sequence[1]}
                interstitials={[
                  {
                    content: <Divider />,
                    count: Number.POSITIVE_INFINITY,
                    frequency: 3,
                  },
                ]}
              />
            </ListViewContext.Provider>
            <Divider />
          </>
        ))}
        {showLoadMore && (
          <ShowMoreButton onClick={onLoadMore} disabled={loadingMore} loading={loadingMore} />
        )}
      </Stack>
    </section>
  );
}

Homepage.propTypes = LANDING_PAGE;

// Module Exports
export { Homepage };
